import React from "react";
import SignUpForm from "../components/SignUpForm";
require("../components/SignUpForm.css");

export default function SignUp() {
  return (
    <div>
      <SignUpForm />
    </div>
  );
}
